'use strict';

module.exports = ['$scope', '$rootScope', '$modalInstance', 'config', 'ProductionScheduleSvc', 'ModalSvc', function ($scope, $rootScope, $modalInstance, config, ProductionScheduleSvc, ModalSvc) {
    // ------------------
    // scope functions
    // ------------------
    $scope.confirmDelete = function () {
        ProductionScheduleSvc.delete(config.entry_id, $scope.$root.plant).success(function (data) {
            $modalInstance.close();
            $rootScope.$broadcast('entryUpdated', data);
        }).error(function (data) {
            console.error(data);
        });
    };

    $scope.cancelClick = function () {
        ModalSvc.productionModeCalendarEntryEditModal.open({entry_id: config.entry_id});
        $modalInstance.close();
    };

    $scope.message = "Are you sure you want to delete this entry?";
}];